module.exports = "/images/image1.jpg?a673d70b6f484d09cc0345c5bf7322bc";